import mixin from '../../mixins/Mixin.js';
export default (editor, config = {}) => {
  const domc = editor.DomComponents;
  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  var modal = null;
  var self;
  let id = 'social-media';
  let type = 'social_media';
  let typeMedia = type;
  domc.addType(type, {
    model: defaultModel.extend(
      {
        defaults: Object.assign({}, defaultModel.prototype.defaults, {
          'custom-name': typeMedia,
          type: typeMedia,
          config: JSON.stringify(config),
          tagName: 'div',
          objectMedia: {
            data: '',
            jsonData: '',
            jsonStyle: '',
            mediaType: '',
            typeShow: '',
          },
          width: '100%',
          height: '100%',
          attributes: { style: 'display: none' },
          style: {
            width: '30%',
            height: '60%',
            overflow: 'hidden',
          },
        }),
        toHTML() {
          return this.view && this.view.el.getAttribute('data-gjs-type') === type
            ? this.view.el.outerHTML
            : '';
        },
        isComponent(el) {
          var result = '';
          if (el.tagName === 'div') {
            result = { type: type, src: el.src };
          }
          return result;
        },
      },
      {
        isComponent(el) {
          var result = '';
          if (el.tagName === 'div') {
            result = { type: type, src: el.src };
          }
          return result;
        },
      },
    ),
    view: defaultView.extend({
      events: {
        // click: 'sendPostMessage',
        dblclick: 'openModal',
      },
      initialize(o) {
        defaultView.prototype.initialize.apply(this, arguments);
        self = this;
        this.listenTo(this.model, 'active', self.insertIframe);
        this.listenTo(this.model, 'change:objectMedia', this.handleUpdate);
        modal = editor.Modal;
      },
      handleUpdate() {
        this.getIframe().innerHTML = this.model.get('objectMedia').data;
        if (this.model.get('objectMedia').data) {
          this.el.innerHTML = this.model.get('objectMedia').data;
        }
      },
      getIframe() {
        if (!this.iframe) {
          var ifrm = document.createElement('div');
          ifrm.className = this.ppfx + 'no-pointer';
          ifrm.id = id + '-' + mixin.methods.makeId();
          ifrm.style = 'width:100%;height:100%;border:none;overflow:hidden';

          this.iframe = ifrm;
        }
        return this.iframe;
      },
      insertIframe() {
        self.el.appendChild(self.getIframe());

        document.getElementById('CanvOverlay').style.display = 'block';
        document.getElementById(id + '-iframe').style.display = 'block';
        let config = JSON.parse(this.model.get('config'));
        let iframeHeight = '800';

        let defaultsUrls = config.route.paramsClient.display_default_urls;
        if (defaultsUrls) {
          let modalContent = document.getElementById('gjs-mdl-c-' + id);
          let imageUrl = defaultsUrls.social_media_url;
          if (imageUrl) {
            modalContent.innerHTML = mixin.methods.setIframePlugin(id, imageUrl, iframeHeight);
          }
        }
        self.openModal();
      },
      closeModal() {
        document.getElementById(id + '-iframe').style.display = 'none';
        document.getElementById('CanvOverlay').style.display = 'none';
        this.handleEmptySocialMedia();
      },
      openModal() {
        document.getElementById(id + '-iframe').style.display = 'block';
        self.sendPostMessage();
        modal.getModel().once('change:open', function() {
          document.getElementById('CanvOverlay').style.display = 'none';
          self.handleEmptySocialMedia();
        });
      },
      sendPostMessage() {
        let selected = grapesjsEMP.editors[0].getSelected();
        window.w = selected;

        if (selected) {
          typeMedia = selected.attributes.objectMedia.currentPost.TypeSocial;
          let objectMedia = selected.attributes.objectMedia;
          let iframeEl = document.getElementById('iframe-' + id);

          let message = {
            info: 'updateSocialMedia',
            currentPost: objectMedia.currentPost,
            data: objectMedia.data,
          };
          iframeEl.contentWindow.postMessage(message, '*');
        }
      },
      render(...args) {
        defaultView.prototype.render.apply(this, args);

        if (this.model.get('objectMedia').data) {
          this.el.innerHTML = this.model.get('objectMedia').data;
        }
        this.updateClasses();
        this.updateAttributes();
        return this;
      },
      handleEmptySocialMedia() {
        const getAllComponents = (model, result = []) => {
          result.push(model);
          model.components().each(mod => getAllComponents(mod, result));
          return result;
        };
        const all = getAllComponents(editor.DomComponents.getWrapper());
        let found = all.some(c => c.attributes.type === type && !c.attributes.objectMedia.data);
        while (found) {
          editor.UndoManager.undo();
          const all = getAllComponents(editor.DomComponents.getWrapper());
          found = all.some(c => c.attributes.type === type && !c.attributes.objectMedia.data);
        }
      },
    }),
  });
};



// WEBPACK FOOTER //
// ./src/plugins/medias/components.js